
<mat-tab-group>
  <mat-tab label="Operaciones">  <app-create-operations
    [companyId]="rutUrl"
    [operations]="operations"
  /> </mat-tab>
  <mat-tab label="Operaciones Aprobadas">  <app-approved-operations
    [companyId]="rutUrl"
    [operationsApproved]="operationsApproved"
  /> </mat-tab>

</mat-tab-group>